/* mox-shadow-cart.js — Drawer 100% draft-only (sin carrito nativo, sin notas/envío/cupones) */
(function () {
    // ======= CONSTANTES ====================================
    const CFG_OBSERVER_TIMEOUT_MS = 5000; // Timeout para MutationObserver (5 segundos)
    const CFG_NODE_ID = 'mox-prereserva-config'; // ID del nodo de configuración JSON
    
    // ======= INICIALIZAR MOX_CFG SI NO EXISTE ====================================
    // Garantizar que window.MOX_CFG esté disponible antes de usarlo
    // Esto evita problemas de orden de carga con mox-draft-timers.js
    // Usa MutationObserver para esperar el JSON si no está disponible inmediatamente
    
    /**
     * Obtiene el nodo de configuración del DOM
     * @returns {HTMLElement|null} El elemento #mox-prereserva-config o null si no existe
     */
    function getCfgNode() {
        return document.getElementById(CFG_NODE_ID);
    }

    /**
     * Valida si un objeto de configuración es válido
     * @param {*} cfg - Objeto a validar
     * @returns {boolean} true si es un objeto válido con propiedades
     */
    function isValidConfig(cfg) {
        return cfg && typeof cfg === 'object' && !Array.isArray(cfg) && Object.keys(cfg).length > 0;
    }
    
    /**
     * Garantiza que window.MOX_CFG esté inicializado con la configuración del DOM
     * Si ya está inicializado y es válido, no hace nada
     * Si no está disponible, intenta leerlo del JSON en el DOM
     */
    function ensureMOXCFG() {
        // Si ya está inicializado y tiene contenido válido, no hacer nada
        if (isValidConfig(window.MOX_CFG)) {
            return; // Ya está inicializado con datos válidos
        }
        
        // Intentar leer la configuración directamente del JSON en el DOM
        try {
            const cfgNode = getCfgNode();
            if (cfgNode && cfgNode.textContent && cfgNode.textContent.trim()) {
                const cfg = JSON.parse(cfgNode.textContent);
                // Solo actualizar si el JSON tiene contenido válido
                if (isValidConfig(cfg)) {
                    window.MOX_CFG = cfg;
                    return; // Configuración cargada exitosamente
                }
            }
        } catch (e) {
            console.warn('[mox-shadow-cart] Error parseando config JSON:', e);
        }
        
        // Si llegamos aquí, el JSON no está disponible aún
        // Inicializar con objeto vacío solo si no existe
        if (!window.MOX_CFG) {
            window.MOX_CFG = {};
        }
    }

    /**
     * Verifica si el nodo de configuración está disponible y tiene contenido
     * @returns {boolean} true si el nodo existe y tiene contenido válido
     */
    function isCfgNodeReady() {
        const cfgNode = getCfgNode();
        return cfgNode && cfgNode.textContent && cfgNode.textContent.trim();
    }
    
    /**
     * Espera a que la configuración esté disponible y ejecuta un callback
     * @param {Function} callback - Función a ejecutar cuando la configuración esté lista
     */
    function waitForCfg(callback) {
        // Si el JSON ya está disponible, ejecutar callback inmediatamente
        if (isCfgNodeReady()) {
            ensureMOXCFG();
            if (callback) callback();
            return;
        }

        // Esperar a que el DOM esté listo
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function onDom() {
                document.removeEventListener('DOMContentLoaded', onDom);
                if (isCfgNodeReady()) {
                    ensureMOXCFG();
                    if (callback) callback();
                    return;
                }
                // Si aún no está, usar MutationObserver
                setupCfgObserver(callback);
            });
        } else {
            // DOM ya está listo, usar MutationObserver
            setupCfgObserver(callback);
        }
    }

    /**
     * Configura un MutationObserver para esperar a que el nodo de configuración esté disponible
     * @param {Function} callback - Función a ejecutar cuando la configuración esté lista
     */
    function setupCfgObserver(callback) {
        const mo = new MutationObserver(function() {
            if (isCfgNodeReady()) {
                mo.disconnect();
                ensureMOXCFG();
                if (callback) callback();
            }
        });
        mo.observe(document.documentElement, { childList: true, subtree: true });
        
        // Timeout de seguridad: después del tiempo configurado, dejar de observar
        setTimeout(function() {
            mo.disconnect();
            // Intentar una última vez
            ensureMOXCFG();
        }, CFG_OBSERVER_TIMEOUT_MS);
    }
    
    // Inicializar inmediatamente si está disponible
    ensureMOXCFG();
    
    // Esperar por el JSON si no está disponible aún
    waitForCfg();
    
    // ======= EXPONER FUNCIONES GLOBALMENTE ====================================
    // Exponer funciones de configuración y utilidad para uso en otros scripts
    // Esto elimina duplicación de código en mox-shadow-cart.liquid
    if (!window.MOX_CFG_UTILS) {
        window.MOX_CFG_UTILS = {
            getCfgNode: getCfgNode,
            ensureMOXCFG: ensureMOXCFG,
            waitForCfg: waitForCfg,
            setupCfgObserver: setupCfgObserver,
            isValidConfig: isValidConfig,
            isCfgNodeReady: isCfgNodeReady
        };
    }
    
    const SEL = {
        root: '#mox-shadow-cart',
        overlay: '[data-mox-overlay]',
        panel: '[data-mox-panel]',
        toggle: '.mox-shadow-cart__toggle',
        close: '[data-mox-close]',
        empty: '[data-mox-empty]',
        items: '[data-mox-items]',
        footer: '[data-mox-footer]',
        toolbar: '[data-mox-toolbar]',
        timerRow: '[data-mox-timer-row]',
        subtotal: '[data-mox-subtotal]',
        subtotalLine: '[data-mox-subtotal-line]',
        shipping: '[data-mox-shipping]',
        shippingContainer: '[data-mox-shipping-container]',
        freeShippingMessage: '[data-mox-free-shipping-message]',
        freeShippingInfo: '[data-mox-free-shipping-info]',
        badge: '[data-mox-cart-count]',
        tpl: '#mox-cart-item-tpl'
    };

    const API_BASE = window.MOX_API_BASE;
    const $ = (r, s) => r.querySelector(s);

    // Flags UI
    const AUTO_OPEN_ON_LOAD = true;
    let openedOnceAfterLoad = false;
    let draftBusy = false;

    // === Badge helper (globito del header) ==================
    window.moxSetCartCount = window.moxSetCartCount || function (n) {
        const el =
            document.querySelector('.mox-shadow-cart__toggle [data-mox-counter]') ||
            document.querySelector('.mox-cart-button [data-mox-counter]') ||
            document.querySelector('.hdt-minicart .hdt-badge');

        if (!el) return;
        const val = Number(n) || 0;
        el.textContent = String(val > 99 ? '99+' : val);
        el.setAttribute('data-mox-counter', String(val));
    };

    // Helpers
    function isDummyLine(li) {
        // Línea personalizada (sin variantId) con título 'draft-dummy'
        return !li?.variant?.id && !li?.variantId && String(li?.title || '').toLowerCase() === 'draft-dummy';
    }


    function gidToNum(gid) {
        if (gid == null) return null;
        const m = String(gid).match(/(\d+)$/);
        return m ? m[1] : null;
    }

    // Map { variantId(str) : qty(num) } desde la draft actual
    function currentQtyMap(draft) {
        const d = draft?.draftOrder ? draft.draftOrder : draft;
        const map = {};
        (d?.lineItems?.nodes || []).forEach(n => {
            const vid = (String(n?.variant?.id || '').match(/(\d+)$/) || [])[1];
            if (vid) map[vid] = Number(n?.quantity || 0);
        });
        return map;
    }

    // Subtotal en el cliente si el backend no trae montos
    function clientSubtotal(nodes) {
        let sum = 0;
        (nodes || []).forEach(li => {
            const q = Number(li?.quantity || 0);
            const discounted = li?.discountedTotalSet?.shopMoney?.amount;
            const original = li?.originalTotalSet?.shopMoney?.amount;
            const unitPrice = li?.originalUnitPriceSet?.shopMoney?.amount ?? li?.variant?.price ?? 0;
            const line = discounted != null ? Number(discounted)
                : original != null ? Number(original)
                    : Number(unitPrice) * q;
            sum += Number(line || 0);
        });
        return sum;
    }

    /**
     * Formatea un número con puntos como separadores de miles (formato COP estándar)
     * @param {number} num - Número a formatear (puede ser positivo o negativo)
     * @returns {string} Número formateado con puntos (ej: 800000 -> "800.000", -800000 -> "-800.000")
     */
    function formatCOPWithDots(num) {
        // Manejar signo negativo por separado para evitar problemas con slice
        const isNegative = num < 0;
        const absNum = Math.abs(Math.round(num));
        const numStr = String(absNum);
        
        // Si el número es 0 o muy pequeño, devolver directamente
        if (numStr.length <= 3) {
            return isNegative ? '-' + numStr : numStr;
        }
        
        // Algoritmo robusto: procesar desde el final del número
        // Agregar puntos cada 3 dígitos desde la derecha
        // Solo agregar punto si hay más dígitos después del grupo de 3
        let formatted = '';
        let count = 0;
        
        // Procesar desde el final hacia el inicio
        for (let i = numStr.length - 1; i >= 0; i--) {
            if (count > 0 && count % 3 === 0) {
                // Agregar punto cada 3 dígitos (desde la derecha)
                // Verificar si hay más dígitos después del grupo de 3
                // Si i > 0, hay más dígitos a la izquierda, así que agregamos punto
                // Si i === 0 pero el número tiene 4 o más dígitos y count >= 3,
                // significa que hay múltiples grupos de 3 (o un grupo completo de 3),
                // así que también agregamos punto
                if (i > 0 || (i === 0 && numStr.length >= 4 && count >= 3)) {
                    formatted = '.' + formatted;
                }
            }
            formatted = numStr[i] + formatted;
            count++;
        }
        
        // Agregar signo negativo si es necesario
        return isNegative ? '-' + formatted : formatted;
    }
    
    // Exponer función de formateo para uso en otros scripts
    // IMPORTANTE: Esta asignación debe estar DESPUÉS de la definición de la función
    if (!window.formatCOPWithDots) {
        window.formatCOPWithDots = formatCOPWithDots;
    }

    function moneyFmt(amount, code) {
        const n = Number(amount) || 0;
        const c = code || (window.Shopify?.currency?.active || 'USD');

        // Monedas sin decimales (COP, CLP, JPY, etc.)
        const ZERO_DECIMAL = new Set(['COP', 'CLP', 'JPY', 'KRW', 'VND', 'ISK']);

        // Para COP, usar formato con puntos como separadores de miles
        if (c === 'COP') {
            const formatted = formatCOPWithDots(n);
            return `COP ${formatted}`;
        }

        const opts = { style: 'currency', currency: c };
        if (ZERO_DECIMAL.has(c)) {
            opts.minimumFractionDigits = 0;
            opts.maximumFractionDigits = 0;
        } else {
            opts.minimumFractionDigits = 2;
            opts.maximumFractionDigits = 2;
        }

        try {
            // usa el locale del navegador; si prefieres, pon 'es-CO'
            return new Intl.NumberFormat(undefined, opts).format(n);
        } catch {
            // Fallback simple si Intl falla
            if (ZERO_DECIMAL.has(c)) return `${c} ${Math.round(n).toLocaleString()}`;
            return '$' + n.toFixed(2);
        }
    }

    function getNumber(v, d = 0) {
        const n = Number(String(v ?? '').replace(/[^\d]/g, ''));
        return Number.isFinite(n) ? n : d;
    }

    function linesFromCurrentWithChange(currentDraft, variantIdNum, newQty) {
        const nodes = currentDraft?.lineItems?.nodes || [];
        const lines = nodes
            .map(n => ({ variantId: gidToNum(n?.variant?.id), quantity: Number(n?.quantity || 0) }))
            .filter(l => l.variantId && l.quantity >= 0);

        const idx = lines.findIndex(l => String(l.variantId) === String(variantIdNum));
        if (idx >= 0) {
            if (newQty <= 0) lines.splice(idx, 1);
            else lines[idx].quantity = newQty;
        } else if (newQty > 0 && variantIdNum) {
            lines.push({ variantId: variantIdNum, quantity: newQty });
        }
        return lines;
    }

    // Convierte snapshot deseado -> deltas para backend
    function computeDeltas(draft, desiredLines) {
        const curr = currentQtyMap(draft); // { vid: qtyActual }
        const deltas = [];

        desiredLines.forEach(l => {
            const vid = String(l.variantId);
            const want = Number(l.quantity || 0);
            const have = Number(curr[vid] || 0);
            const delta = want - have;
            if (delta !== 0) deltas.push({ variantId: vid, quantity: delta });
            delete curr[vid];
        });

        // Lo que quedó en curr se elimina
        Object.keys(curr).forEach(vid => {
            const have = Number(curr[vid] || 0);
            if (have > 0) deltas.push({ variantId: vid, quantity: -have });
        });

        return deltas;
    }

    function init(root) {
        if (!root) return;
        // Guard para no bindear dos veces si la sección se reinyecta
        if (root.dataset.moxBound === '1') return;
        root.dataset.moxBound = '1';

        const overlay = $(root, SEL.overlay);
        const panel = $(root, SEL.panel);
        const toggle = $(root, SEL.toggle);
        const btnClose = $(root, SEL.close);
        const list = $(root, SEL.items);
        const empty = $(root, SEL.empty);
        const footer = $(root, SEL.footer);
        const toolbar = $(root, SEL.toolbar);
        const timerRow = $(root, SEL.timerRow);
        const subtotal = $(root, SEL.subtotal);
        const subtotalLine = $(root, SEL.subtotalLine);
        const shipping = $(root, SEL.shipping);
        const shippingContainer = $(root, SEL.shippingContainer);
        const freeShippingMessage = $(root, SEL.freeShippingMessage);
        const freeShippingInfo = $(root, SEL.freeShippingInfo);
        const badge = $(root, SEL.badge);
        const tpl = $(root, SEL.tpl);

        let lastForcedDraftSyncAt = 0;
        function forceDraftSync() {
            const now = Date.now();
            if (now - lastForcedDraftSyncAt < 300) return;
            lastForcedDraftSyncAt = now;

            // Si la página volvió desde bfcache, refreshing puede quedar "pegado".
            // Forzamos una nueva consulta para evitar drawer vacío por estado viejo.
            if (window.MOX_DRAFT && window.MOX_DRAFT.refreshing) {
                window.MOX_DRAFT.refreshing = false;
            }
            try { window.bootDraftRefresh?.(true); } catch (e) { console.warn('bootDraftRefresh error', e); }
        }

        const open = () => {
            forceDraftSync();
            if (overlay) overlay.hidden = false;
            panel?.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            toggle?.setAttribute('aria-expanded', 'true');
        };
        const close = () => {
            if (overlay) overlay.hidden = true;
            panel?.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
            document.body.classList.remove('mox-no-scroll');
            document.documentElement.style.overflow = '';
            toggle?.setAttribute('aria-expanded', 'false');
        };
        toggle?.addEventListener('click', open);
        btnClose?.addEventListener('click', close);
        overlay?.addEventListener('click', close);
        document.addEventListener('keydown', e => e.key === 'Escape' && close());
        document.addEventListener('mox:shadow:open', open);
        window.addEventListener('mox:shadow:open', open);
        window.addEventListener('mox:bfcache:restored', forceDraftSync);
        window.addEventListener('pageshow', function (event) {
            if (!event.persisted) return;
            forceDraftSync();
        });

        async function updateLines(nextSnapshotLines) {
            if (draftBusy) return;
            draftBusy = true;

            const current = window.MOX_DRAFT?.current;
            if (!current) { draftBusy = false; return; }
            const draftIdNum = gidToNum(current.id);

            try {
                const deltas = computeDeltas(current, nextSnapshotLines);
                if (!deltas.length) { draftBusy = false; return; }

                const res = await fetch(`${API_BASE}/draft-orders/${draftIdNum}/items?shop=babalu-b2b.myshopify.com`, {
                    method: 'POST',
                    headers: window.MOX_HEADERS ? window.MOX_HEADERS() : { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ lineItems: deltas })
                });
                const data = await res.json().catch(() => ({}));

                if (data?.deletedId) {
                    window.MOX_DRAFT.current = null;
                    window.dispatchEvent(new CustomEvent('mox:draft:none'));
                    draftBusy = false;
                    return;
                }
                await window.MOX_DRAFT.refreshById(draftIdNum);
            } catch (e) {
                console.warn('[MOX] Error actualizando líneas:', e);
            } finally {
                draftBusy = false;
            }
        }

        async function updateDeltas(deltas) {
            if (draftBusy) return;
            draftBusy = true;

            const current = window.MOX_DRAFT?.current;
            if (!current) { draftBusy = false; return; }
            const draftIdNum = gidToNum(current.id);

            try {
                if (!Array.isArray(deltas) || !deltas.length) { draftBusy = false; return; }
                const res = await fetch(`${API_BASE}/draft-orders/${draftIdNum}/items?shop=babalu-b2b.myshopify.com`, {
                    method: 'POST',
                    headers: window.MOX_HEADERS ? window.MOX_HEADERS() : { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ lineItems: deltas })
                });
                const data = await res.json().catch(() => ({}));
                if (data?.deletedId) {
                    window.MOX_DRAFT.current = null;
                    window.dispatchEvent(new CustomEvent('mox:draft:none'));
                    draftBusy = false;
                    return;
                }
                await window.MOX_DRAFT.refreshById(draftIdNum);
            } catch (e) {
                console.warn('[MOX] Error aplicando deltas:', e);
            } finally {
                draftBusy = false;
            }
        }

        async function removeVariant(variantIdNum) {
            const map = currentQtyMap(window.MOX_DRAFT?.current);
            const vid = String(variantIdNum);
            const have = Number(map[vid] || 0);
            if (have <= 0) return;
            await updateDeltas([{ variantId: vid, quantity: -have }]);
        }

        function renderFromDraft(draft) {
            // Acepta {draftOrder: {...}} o el objeto plano
            draft = draft?.draftOrder ? draft.draftOrder : draft;

            // Filtrar el dummy para la UI
            const allNodes = draft?.lineItems?.nodes || [];
            const nodes = allNodes.filter(n => !isDummyLine(n));

            // Moneda
            const currency =
                draft?.totalPriceSet?.shopMoney?.currencyCode ||
                draft?.subtotalPriceSet?.shopMoney?.currencyCode ||
                (window.Shopify?.currency?.active);

            // Badge (solo reales)
            const totalQty = nodes.reduce((a, li) => a + (Number(li.quantity) || 0), 0);
            // Actualizar todos los badges con data-mox-cart-count (incluyendo el del título y hdt-cart-count)
            // El selector [data-mox-cart-count] ya incluye todos los elementos con ese atributo, incluyendo hdt-cart-count
            const allBadges = document.querySelectorAll('[data-mox-cart-count]');
            allBadges.forEach(b => {
                b.textContent = String(totalQty);
                // Ocultar si es 0, mostrar si es mayor a 0
                if (totalQty === 0) {
                    b.hidden = true;
                } else {
                    b.hidden = false;
                }
            });
            if (window.moxSetCartCount) window.moxSetCartCount(totalQty);

            // Vistas base (si no hay reales => "carrito vacío")
            if (!nodes.length) {
                empty.hidden = false;
                if (list) list.hidden = true;
                if (footer) footer.hidden = true;
                // toolbar está permanentemente oculto con CSS display: none !important
                if (timerRow) timerRow.hidden = true;
                // Cuando el footer está oculto, no necesitamos gestionar elementos hijos
                // Solo actualizamos valores para cuando el footer se muestre nuevamente
                if (subtotal) {
                    subtotal.textContent = moneyFmt(0, currency);
                    subtotal.setAttribute('data-mox-subtotal-amount', '0');
                }
                if (subtotalLine) subtotalLine.textContent = moneyFmt(0, currency);
                if (shipping) shipping.textContent = 'Por calcular';
                // Ocultar explícitamente mensajes de envío cuando el carrito está vacío
                // para evitar que queden visibles desde un estado anterior
                if (shippingContainer) shippingContainer.hidden = true;
                if (freeShippingMessage) freeShippingMessage.hidden = true;
                if (freeShippingInfo) freeShippingInfo.hidden = true;
                // Nota: No gestionamos visibilidad de hijos cuando footer está oculto
                // Estos se gestionarán cuando el footer se muestre (cuando hay items)
                if (window.moxSetCartCount) window.moxSetCartCount(0);

                // Deshabilitar checkout cuando solo queda el dummy
                const btn = document.querySelector('[data-mox-checkout]');
                if (btn) {
                    btn.setAttribute('disabled', '');
                    btn.setAttribute('aria-disabled', 'true');
                    btn.href = '#';
                }
                return;
            }

            // Hay reales -> UI normal
            empty.hidden = true;
            if (list) list.hidden = false;
            if (footer) footer.hidden = false;
            // toolbar está permanentemente oculto con CSS display: none !important
            // El timer se muestra/oculta automáticamente por mox-draft-timers.js según si hay draft activo

            // Subtotal (prefiere server; fallback al cálculo local con reales)
            const subAmount =
                (draft?.subtotalPriceSet?.shopMoney?.amount != null
                    ? Number(draft.subtotalPriceSet.shopMoney.amount)
                    : (draft?.totalPriceSet?.shopMoney?.amount != null
                        ? Number(draft.totalPriceSet.shopMoney.amount)
                        : clientSubtotal(nodes)));

            // Calcular envío: usar costo desde configuración o default
            // Asegurar que MOX_CFG esté disponible antes de leerlo
            ensureMOXCFG();
            // Leer umbral y costo desde configuración o usar defaults
            // Usar ?? en lugar de || para permitir valores 0 intencionales
            const cfg = window.MOX_CFG || {};
            const FREE_SHIPPING_THRESHOLD = Number(cfg.free_shipping_threshold ?? 999000);
            const SHIPPING_COST = Number(cfg.shipping_cost ?? 25000);
            let shippingAmount = 0;
            let shippingText = 'Por calcular';

            if (subAmount > 0 && subAmount < FREE_SHIPPING_THRESHOLD) {
                shippingAmount = SHIPPING_COST;
                shippingText = moneyFmt(shippingAmount, currency);
            } else if (subAmount >= FREE_SHIPPING_THRESHOLD) {
                shippingAmount = 0;
                shippingText = moneyFmt(0, currency);
            }

            // Actualizar subtotal (sin envío)
            if (subtotalLine) subtotalLine.textContent = moneyFmt(subAmount, currency);

            // Leer flags booleanos desde configuración (defaults: true si no están definidos)
            const SHOW_SHIPPING_LINE = cfg.show_shipping_line !== false; // default: true
            const SHOW_FREE_SHIPPING_MESSAGE = cfg.show_free_shipping_message !== false; // default: true
            const SHOW_FREE_SHIPPING_INFO = cfg.show_free_shipping_info !== false; // default: true

            // Actualizar envío y mostrar/ocultar según corresponda
            // Distinguir entre: carrito vacío, envío gratis (por umbral), y envío con costo
            if (subAmount === 0) {
                // Carrito vacío: ocultar todo (el footer ya está oculto, pero mantenemos lógica correcta)
                if (shippingContainer) shippingContainer.hidden = true;
                if (freeShippingMessage) freeShippingMessage.hidden = true;
                if (freeShippingInfo) freeShippingInfo.hidden = true;
                if (shipping) shipping.textContent = 'Por calcular';
            } else if (shippingAmount === 0 && subAmount >= FREE_SHIPPING_THRESHOLD) {
                // Envío gratis: ocultar línea de envío, mostrar mensaje verde (si está habilitado), ocultar info de umbral
                if (shippingContainer) shippingContainer.hidden = true;
                if (freeShippingMessage) freeShippingMessage.hidden = !SHOW_FREE_SHIPPING_MESSAGE;
                if (freeShippingInfo) freeShippingInfo.hidden = true;
            } else {
                // Hay costo de envío: mostrar línea de envío (si está habilitado), ocultar mensaje verde, mostrar info de umbral (si está habilitado)
                if (shippingContainer) shippingContainer.hidden = !SHOW_SHIPPING_LINE;
                if (freeShippingMessage) freeShippingMessage.hidden = true;
                if (freeShippingInfo) freeShippingInfo.hidden = !SHOW_FREE_SHIPPING_INFO;
                if (shipping) shipping.textContent = shippingText;
            }

            // Total = Subtotal + Envío
            const totalAmount = subAmount + shippingAmount;
            if (subtotal) {
                subtotal.textContent = moneyFmt(totalAmount, currency);
                // Guardar subtotal real en data attribute para validaciones
                subtotal.setAttribute('data-mox-subtotal-amount', String(subAmount));
            }

            // Rehabilitar checkout
            const btn = document.querySelector('[data-mox-checkout]');
            if (btn) {
                btn.removeAttribute('disabled');
                btn.removeAttribute('aria-disabled');
                // Restaurar href con múltiples niveles de fallback para garantizar un href válido
                // Prioridad 1: invoiceUrl (URL de invoice del draft order)
                if (btn.dataset.invoiceUrl) {
                    btn.href = btn.dataset.invoiceUrl;
                } 
                // Prioridad 2: originalCheckoutUrl (URL guardada durante inicialización)
                else if (btn.dataset.originalCheckoutUrl) {
                    btn.href = btn.dataset.originalCheckoutUrl;
                } 
                // Prioridad 3: data-checkout-url (atributo HTML del botón)
                else if (btn.dataset.checkoutUrl) {
                    btn.href = btn.dataset.checkoutUrl;
                    // Guardar para futuras referencias
                    btn.dataset.originalCheckoutUrl = btn.dataset.checkoutUrl;
                } 
                // Prioridad 4: href actual del botón (si es válido)
                else {
                    const currentHref = btn.getAttribute('href') || btn.href;
                    if (currentHref && currentHref !== '#' && currentHref !== '') {
                        btn.href = currentHref;
                        // Guardar para futuras referencias
                        btn.dataset.originalCheckoutUrl = currentHref;
                    } 
                    // Prioridad 5: Fallback seguro a checkout estándar de Shopify
                    else {
                        // Último recurso: usar checkout estándar de Shopify
                        btn.href = '/checkout';
                        // Guardar para futuras referencias
                        btn.dataset.originalCheckoutUrl = '/checkout';
                    }
                }
            }

            // Render de items (solo reales)
            if (!list || !tpl?.content?.firstElementChild) return;
            list.innerHTML = '';
            nodes.forEach(li => {
                const node = tpl.content.firstElementChild.cloneNode(true);

                const variantGid = li?.variant?.id;
                const variantIdNum = gidToNum(variantGid);
                node.dataset.key = variantIdNum || '';

                const imgEl = node.querySelector('[data-img]');
                const imgUrl = li?.variant?.image?.url || li?.image?.url || '';
                if (imgEl) { imgEl.src = imgUrl; imgEl.alt = li?.title || li?.variant?.title || 'Producto'; }

                const titleEl = node.querySelector('[data-title]');
                const pTitle = li?.product?.title || li?.variant?.product?.title || li?.title || 'Producto';
                const pUrl = li?.product?.onlineStoreUrl || li?.variant?.product?.onlineStoreUrl || '#';
                if (titleEl) { 
                    titleEl.textContent = pTitle; 
                    titleEl.href = pUrl;
                    // Agregar tooltip con el título completo para cuando esté truncado
                    titleEl.setAttribute('title', pTitle);
                }

                // === ADD: fallback a /products/{handle} si no vino onlineStoreUrl
                if (titleEl && (!pUrl || pUrl === '#')) {
                    const handle =
                        li?.product?.handle ||
                        li?.variant?.product?.handle ||
                        '';
                    if (handle) titleEl.href = `/products/${handle}`;
                }

                // === ADD: hacer clickeable la imagen con el mismo enlace del título
                const mediaBox = node.querySelector('.mox-item__media');
                if (mediaBox && titleEl?.href) {
                    mediaBox.style.cursor = 'pointer';
                    mediaBox.addEventListener('click', () => {
                        window.location.href = titleEl.href;
                    });
                }

                // --- Helpers locales para parsear Color/Talla desde el "name" clásico ---
                function parseColorTalla(nameLike) {
                    const out = { color: '', talla: '' };
                    const name = String(nameLike || '').trim();
                    if (!name) return out;

                    // Tomar la parte después del " - "
                    const afterDash = name.split(' - ').pop()?.trim() || '';
                    if (!afterDash) return out;

                    // Separar por "/" (Color / Talla)
                    const parts = afterDash.split('/').map(s => (s || '').trim()).filter(Boolean);

                    // Caso estándar: "1 NEGRO / M" -> color = "NEGRO" (sin prefijo numérico), talla = "M"
                    if (parts.length >= 1) {
                        out.color = parts[0].replace(/^\d+\s+/, ''); // quita prefijo "1 "
                    }
                    if (parts.length >= 2) {
                        out.talla = parts[1];
                    }

                    // Limpieza final
                    out.color = out.color.replace(/\s+/g, ' ').trim();
                    out.talla = out.talla.replace(/\s+/g, ' ').trim();
                    return out;
                }

                // ****** PARA AGREGAR NOMBRE COLOR TALLA EN EL MINICART A CADA ITEM *****
                const varEl = node.querySelector('[data-variant]');
                if (varEl) {
                    // Fuente principal: li.name (trae "Producto - Color / Talla")
                    const nameLike =
                        li?.name ||
                        li?.variant?.title ||
                        li?.title || '';

                    const { color, talla } = parseColorTalla(nameLike);

                    // Ref (SKU)
                    const sku = (li?.variant?.sku || li?.sku || '').trim();

                    const parts = [];
                    if (color) parts.push(`Color: ${color}`);
                    if (talla) parts.push(`Talla: ${talla}`);
                    if (sku) parts.push(`Ref: ${sku}`);

                    if (!parts.length) {
                        // Fallback último: mostrar variant.title si no es "Default Title"
                        const vt = (li?.variant?.title || '').trim();
                        if (vt && vt !== 'Default Title') parts.push(vt);
                    }

                    if (parts.length) {
                        varEl.textContent = parts.join(' · ');
                        varEl.hidden = false;
                    } else {
                        varEl.textContent = '';
                        varEl.hidden = true;
                    }
                }


                const qtyInput = node.querySelector('[data-qty]');
                const initialQty = Number(li.quantity || 1);
                if (qtyInput) qtyInput.value = String(initialQty);

                const priceEl = node.querySelector('[data-line-price]');
                const q = Number(li.quantity || 0);

                let lineAmt = li?.discountedTotalSet?.shopMoney?.amount;
                if (lineAmt == null) lineAmt = li?.originalTotalSet?.shopMoney?.amount;
                if (lineAmt == null) {
                    const unit = li?.variant?.price || li?.originalUnitPriceSet?.shopMoney?.amount || 0;
                    lineAmt = Number(unit) * q;
                }
                if (priceEl) priceEl.textContent = moneyFmt(lineAmt, currency);

                // Controles
                node.querySelector('[data-decrease]')?.addEventListener('click', async () => {
                    if (draftBusy) return;
                    const current = window.MOX_DRAFT?.current;
                    const curQty = getNumber(qtyInput?.value, initialQty);
                    const nextQty = Math.max(0, curQty - 1);
                    const nextLines = linesFromCurrentWithChange(current, variantIdNum, nextQty);
                    await updateLines(nextLines);
                });

                node.querySelector('[data-increase]')?.addEventListener('click', async () => {
                    if (draftBusy) return;
                    const current = window.MOX_DRAFT?.current;
                    const curQty = getNumber(qtyInput?.value, initialQty);
                    const nextQty = curQty + 1;
                    const nextLines = linesFromCurrentWithChange(current, variantIdNum, nextQty);
                    await updateLines(nextLines);
                });

                qtyInput?.addEventListener('change', async () => {
                    if (draftBusy) return;
                    const current = window.MOX_DRAFT?.current;
                    const nextQty = Math.max(0, getNumber(qtyInput?.value, initialQty));
                    const nextLines = linesFromCurrentWithChange(current, variantIdNum, nextQty);
                    await updateLines(nextLines);
                });

                node.querySelector('[data-remove]')?.addEventListener('click', async () => {
                    if (draftBusy) return;
                    await removeVariant(variantIdNum);
                });

                list.appendChild(node);
            });
        }


        // Ciclo de vida de la draft
        window.addEventListener('mox:draft:loaded', (e) => {
            window.MOX_DRAFT = window.MOX_DRAFT || {};
            window.MOX_DRAFT.current = e.detail?.draft || null;
            renderFromDraft(window.MOX_DRAFT.current);

            // Auto-open una sola vez si hay items (opcional)
            try {
                if (AUTO_OPEN_ON_LOAD && !openedOnceAfterLoad) {
                    const d = window.MOX_DRAFT.current?.draftOrder ? window.MOX_DRAFT.current.draftOrder : window.MOX_DRAFT.current;
                    const hasItems = Array.isArray(d?.lineItems?.nodes) && d.lineItems.nodes.length > 0;
                    // if (hasItems) { openedOnceAfterLoad = true; open(); }
                }
            } catch { /* no-op */ }
        });

        window.addEventListener('mox:draft:none', () => {
            window.MOX_DRAFT = window.MOX_DRAFT || {};
            window.MOX_DRAFT.current = null;
            // Actualizar todos los badges con data-mox-cart-count (incluyendo el del título y hdt-cart-count)
            // El selector [data-mox-cart-count] ya incluye todos los elementos con ese atributo, incluyendo hdt-cart-count
            const allBadges = document.querySelectorAll('[data-mox-cart-count]');
            allBadges.forEach(b => {
                b.textContent = '0';
                b.hidden = true;
            });
            const emptyEl = $(root, SEL.empty);
            const listEl = $(root, SEL.items);
            const footerEl = $(root, SEL.footer);
            const timerRowEl = $(root, SEL.timerRow);
            const shippingContainerEl = $(root, SEL.shippingContainer);
            const freeShippingMessageEl = $(root, SEL.freeShippingMessage);
            const freeShippingInfoEl = $(root, SEL.freeShippingInfo);
            if (emptyEl) emptyEl.hidden = false;
            if (listEl) listEl.hidden = true;
            if (footerEl) footerEl.hidden = true;
            // toolbar está permanentemente oculto con CSS display: none !important
            if (timerRowEl) timerRowEl.hidden = true;
            // Cuando el footer está oculto, no necesitamos gestionar elementos hijos
            // Solo actualizamos valores para cuando el footer se muestre nuevamente
            const currency = window.Shopify?.currency?.active || 'USD';
            const subtotalEl = $(root, SEL.subtotal);
            const subtotalLineEl = $(root, SEL.subtotalLine);
            const shippingEl = $(root, SEL.shipping);
            if (subtotalEl) {
                subtotalEl.textContent = moneyFmt(0, currency);
                subtotalEl.setAttribute('data-mox-subtotal-amount', '0');
            }
            if (subtotalLineEl) subtotalLineEl.textContent = moneyFmt(0, currency);
            if (shippingEl) shippingEl.textContent = 'Por calcular';
            // Ocultar explícitamente mensajes de envío cuando el carrito está vacío
            // para evitar que queden visibles desde un estado anterior
            if (shippingContainerEl) shippingContainerEl.hidden = true;
            if (freeShippingMessageEl) freeShippingMessageEl.hidden = true;
            if (freeShippingInfoEl) freeShippingInfoEl.hidden = true;
            // Nota: No gestionamos visibilidad de hijos cuando footer está oculto
            // Estos se gestionarán cuando el footer se muestre (cuando hay items)
        });

        // Exponer helpers mínimos
        window.MOX_CART = {
            open,
            close,
            updateDeltas,  // 👈 expuesta
            updateLines,   // opcional
            removeVariant  // opcional
        };


        // Estado inicial
        if (window.MOX_DRAFT?.current) {
            renderFromDraft(window.MOX_DRAFT.current);
        } else {
            window.dispatchEvent(new CustomEvent('mox:draft:none'));
        }
    }

    function ready(fn) {
        document.readyState === 'loading'
            ? document.addEventListener('DOMContentLoaded', fn, { once: true })
            : fn();
    }

    ready(() => init(document.querySelector(SEL.root)));

    // Rebind al recargar secciones en Theme Editor / Ajax
    document.addEventListener('shopify:section:load', e => {
        const root = e.target?.querySelector?.(SEL.root);
        if (root) init(root);
    });

})();

/* === Shadow cart: cerrar con overlay / fuera del panel, y sincronizar estados === */
(() => {
    // evitar doble binding si el archivo se inyecta dos veces
    if (window.__moxOverlayBound) return;
    window.__moxOverlayBound = true;

    const drawer = document.querySelector('[data-mox-shadow-cart]') ||
        document.getElementById('mox-shadow-cart') ||
        document.querySelector('.mox-shadow-cart');

    if (!drawer) return;

    const overlay = document.querySelector('#mox-shadow-overlay, [data-mox-overlay]');
    const panel = drawer.querySelector('[data-mox-panel]') || drawer;

    // si por alguna razón no existiera overlay, lo creamos (casi nunca pasa)
    let _overlay = overlay;
    if (!_overlay) {
        _overlay = document.createElement('div');
        _overlay.id = 'mox-shadow-overlay';
        document.body.appendChild(_overlay);
    }

    const setOpen = (open) => {
        // clase para z-index y estilos
        drawer.classList.toggle('is-open', open);

        // overlay visible/oculto (clase + atributo hidden)
        _overlay.classList.toggle('is-visible', open);
        _overlay.hidden = !open;

        // accesibilidad del panel
        panel?.setAttribute('aria-hidden', String(!open));

        // opcional: bloquear scroll del body al abrir
        document.documentElement.classList.toggle('mox-no-scroll', open);
        document.body.classList.toggle('mox-no-scroll', open);

        document.body.style.overflow = open ? 'hidden' : '';
        document.documentElement.style.overflow = open ? 'hidden' : '';
    };

    // abrir/cerrar desde eventos globales (lo que ya usas en tu app)
    document.addEventListener('mox:shadow:open', () => setOpen(true));
    document.addEventListener('mox:shadow:close', () => setOpen(false));

    // click en overlay => cerrar
    _overlay.addEventListener('click', () => setOpen(false));

    // click fuera del panel => cerrar (por seguridad)
    document.addEventListener('click', (e) => {
        if (!drawer.classList.contains('is-open')) return;
        // si el click no fue dentro del panel ni sobre el overlay => cerrar
        if (!panel.contains(e.target) && e.target !== _overlay) {
            setOpen(false);
        }
    }, true);

    // tecla Escape => cerrar
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    });
})();


